export enum TargetSettingDialogStep {
  TEASER,
  GUIDE,
  SETUP_PRODUCTIVITY_TARGET,
  SETUP_HOURLY_WAGE,
  SETUP_LABOURCOST_PERCENTAGE,
  TURNOVER_GUIDANCE,
  WAGES,
  SUMMARY,
}
